
export class Sector {
    id: number;
    name: string;
    nameFr: string;
}
